export default __webpack_public_path__ + "static/media/playstore_icon.a016f7c9.png";